<template>
  <div>
    <clinicList
      :canEdit="true"
      editRoute="SuperAdminClinicEdit"
      :canCreate="true"
      createRoute="SuperAdminClinicCreate"
      :canViewDetail="true"
      viewRoute="SuperAdminClinicDetail"
    />
  </div>
</template>

<script>
import clinicList from '../../components/clinics/vendorAssociatedClinicList.vue';

export default {
  components: {
    clinicList,
  },
  data: () => ({}),
};
</script>
